import React from 'react';
import type { AteQuando } from '../../../../src/lib/avisosUc';

// "Até quando o aviso vale": sem prazo (até alguém encerrar), até um mês, ou só o
// mês de início. Usado ao criar e ao alterar o prazo de um aviso.
interface Props {
    /** Meses que podem ser escolhidos como fim ("OUT/2026"...). */
    meses: string[];
    inicio: string;
    valor: AteQuando;
    onChange: (v: AteQuando) => void;
}

const OPCOES: { tipo: AteQuando['tipo']; rotulo: string; ajuda: string }[] = [
    { tipo: 'sem_prazo', rotulo: 'Sem prazo', ajuda: 'Aparece em todas as faturas até alguém encerrar o aviso.' },
    { tipo: 'ate', rotulo: 'Até um mês', ajuda: 'No último mês o cálculo avisa que o aviso termina ali.' },
    { tipo: 'so_este', rotulo: 'Só este mês', ajuda: 'Vale apenas na fatura do mês de início.' },
];

const SeletorAteQuando: React.FC<Props> = ({ meses, inicio, valor, onChange }) => {
    const iniIdx = meses.indexOf(inicio);
    const mesesDepois = iniIdx >= 0 ? meses.slice(iniIdx) : meses;
    const mesAte = valor.tipo === 'ate' ? valor.mes : (mesesDepois[Math.min(2, mesesDepois.length - 1)] ?? inicio);

    return (
        <div className="space-y-2">
            {OPCOES.map(op => {
                const marcado = valor.tipo === op.tipo;
                return (
                    <label
                        key={op.tipo}
                        className={`flex items-start gap-3 p-3 border rounded-xl cursor-pointer transition-all ${marcado
                            ? 'border-primary bg-primary/5 ring-1 ring-primary/30'
                            : 'border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800'}`}
                    >
                        <input
                            type="radio"
                            name="ate-quando"
                            className="mt-1 accent-primary"
                            checked={marcado}
                            onChange={() => onChange(op.tipo === 'ate' ? { tipo: 'ate', mes: mesAte } : { tipo: op.tipo } as AteQuando)}
                        />
                        <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 flex-wrap">
                                <span className="text-sm font-semibold text-gray-800 dark:text-white">{op.rotulo}</span>
                                {op.tipo === 'ate' && marcado && (
                                    <select
                                        value={mesAte}
                                        onChange={e => onChange({ tipo: 'ate', mes: e.target.value })}
                                        onClick={e => e.stopPropagation()}
                                        className="text-sm border border-gray-200 dark:border-gray-700 rounded-lg px-2 py-1 bg-white dark:bg-gray-900 dark:text-white"
                                        aria-label="Último mês do aviso"
                                    >
                                        {mesesDepois.map(m => <option key={m} value={m}>{m}</option>)}
                                    </select>
                                )}
                            </div>
                            <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{op.ajuda}</p>
                        </div>
                    </label>
                );
            })}
        </div>
    );
};

export default SeletorAteQuando;
